import { RouteRecordRaw } from "vue-router";
import store from "@/store";

export const faqRoutes: Array<RouteRecordRaw> = [
  {
    path: "faq",
    name: "faq",
    component: () => import("@/views/faq-view/faq-view.vue")
  },
  {
    path: "faq/1",
    name: "faq-1",
    component: () => import("@/views/faq/faq-one-view/faq-one-view.vue")
  },
  {
    path: "faq/2",
    name: "faq-2",
    component: () => import("@/views/faq/faq-two-view/faq-two-view.vue")
  },
  {
    path: "faq/3",
    name: "faq-3",
    component: () => import("@/views/faq/faq-three-view/faq-three-view.vue")
  },
  {
    path: "faq/4",
    name: "faq-4",
    component: () => import("@/views/faq/faq-four-view/faq-four-view.vue")
  },
  {
    path: "faq/5",
    name: "faq-5",
    component: () => import("@/views/faq/faq-five-view/faq-five-view.vue")
  },
  {
    path: "faq/6",
    name: "faq-6",
    component: () => import("@/views/faq/faq-six-view/faq-six-view.vue")
  }
];
